import React from "react";
import { Row, Col, Well } from "react-bootstrap";
import StartupsProductOverviewLayout from "./StartupsProductOverviewLayout";

const NoAvailableProductsHint = () => {
  return (
    <StartupsProductOverviewLayout>
      <Row>
        <Col md={10} mdPush={1} className="text-center">
          <Well>
            <p>Bisher keine Produktsorten angelegt!</p>
            <br />
            <a href="/startups/products/new" className="btn btn-secondary">
              Neue Produktsorte anlegen
            </a>
          </Well>
        </Col>
      </Row>
    </StartupsProductOverviewLayout>
  );
};

export default NoAvailableProductsHint;
